import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { productAccessName } from '../../shared/constant';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/shared/services/token.service';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BusinessEntityService } from 'src/app/shared/services/business-entity.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  @ViewChild('signup') signupTemplate!: TemplateRef<any>; // template ref
  private modalRef!: NgbModalRef; // modal ref
  productAccessName: { onyx: string; topaz: string; sapphire: string; };
  isTopazAccessable: any = false;
  isOnyxAccessable: any = false;
  isSapphireAccessable: any = false;
  isLMSAccessable: any = false;
  isASAPAccessable: any = false;
  isExpressTDSAccessible: any = false;
  getToken: any;
  currentProductAccess: string;
  getSapphireTenent: string;
  signUpStep = 'OTP_NOT_SENT';
  dtUserDetails: any;
  dtLoginResp: any;
  dtSignupForm: FormGroup;
  otpForm: FormGroup;
  dtUserRole = ''; // dt_master or dt_sub_user
  private phoneValidators = [
    Validators.required,
    Validators.pattern('^[0-9]{10}$')
  ];

  private pinCodeValidators = [
    Validators.required,
    Validators.pattern('^[0-9]{6}$')
  ];

  constructor(
    private router: Router,
    private tokenService:TokenService,
    private modalService: NgbModal,
    private businessEntityService: BusinessEntityService,
    private authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService

  ) {
    this.productAccessName = productAccessName;
  }

  ngOnInit() {
    this.dtSignupForm = this.fb.group({
      phone: new FormControl('', this.phoneValidators),
      pinCode: new FormControl('', this.pinCodeValidators)
    });
    this.otpForm = this.fb.group({
      otp: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6}$')])
    })
    this.currentProductAccess = localStorage.getItem('products');
    let tempArrProduct = this.currentProductAccess.split(',');
    if (tempArrProduct) {
      tempArrProduct.forEach(e => {
        if (e == 'TOPAZ') {
          this.isTopazAccessable = true;
        }
        if (e == 'ONYX') {
          this.isOnyxAccessable = true;
        }
        if (e == 'SAPPHIRE') {
          this.isSapphireAccessable = true;
        }
        if (e == 'LMS') {
          this.isLMSAccessable = true;
        }
        if (e == 'ASAP') {
          this.isASAPAccessable = true;
        }
        if(e == 'DT'){
          this.isExpressTDSAccessible = true;
          this.fetchDTUserDetails();
        }
      });
    }
  }

  private removeRequired(control: AbstractControl | null): void {
    if (!control) return;

    // clone the array but skip the first element (Validators.required)
    const newValidators = this.pinCodeValidators.slice(1);

    control.setValidators(newValidators);
    control.updateValueAndValidity();
    this.dtSignupForm.updateValueAndValidity();
  }

  fetchDTUserDetails() {
    this.businessEntityService.fetchDTUserDetails().subscribe((res: any) => {
      if (res && res.status == 'SUCCESS') {
        if (res.response) {
          this.dtUserDetails = res.response;
          this.dtUserRole = res.response.role;
          localStorage.setItem('DT_USER_ROLE', this.dtUserRole);
          if(this.dtUserDetails.signUp) {
            if (this.dtUserRole === 'dt_sub_user') {
              this.removeRequired(this.dtSignupForm.get('pinCode'));
            }
            this.dtLogin();
          }
        }
      }
    });
  }

  dtLogin(redirect = false) {
    this.authService.dtLogin().subscribe((res: any) => {
      if (res && res.status == 'SUCCESS') {
        if (res.response) {
          this.dtLoginResp = res.response;
          if(redirect) {
             window.open(`https://${environment.expressTDSUrl}${this.dtLoginResp.token}`, '_blank');
          }

        }
      }
    });
  }

  gotoProduct(product) {
    this.getToken = localStorage.getItem('logintoken') ? localStorage.getItem('logintoken') : null;
    this.getSapphireTenent = localStorage.getItem('sapphireTenent') ? localStorage.getItem('sapphireTenent') : null;
    if (this.getToken) {
      switch (product) {
        case 'topaz':
          window.open(`https://${environment.topazUrl}/#/tokenVerify?token=${this.getToken}`, '_blank');
          // window.open(`http://localhost:9000/#/tokenVerify?token=${this.getToken}`, '_blank');
          break;
        case 'onyx':
          window.open(`https://${environment.onyxUrl}/token-verify?token=${this.getToken}`, '_blank');
          // window.open(`http://localhost:4100/token-verify?token=${this.getToken}`, '_blank');
          break;
        case 'sapphire':
          if(environment.sapphireUrl){
            window.open(`https://${this.getSapphireTenent}${environment.sapphireUrl}/#/tokenVerify?token=${this.getToken}&sapphireTenent=${this.getSapphireTenent}`, '_blank');
          }
          // window.open(`http://localhost:9000/#/tokenVerify?token=${this.getToken}&sapphireTenent=${this.getSapphireTenent}`, '_blank');
          break;
          case 'lms':
            window.open(`https://${environment.lmsUrl}/token-verify?token=${this.getToken}`, '_blank');
            //window.open(`http://localhost:4100/token-verify?token=${this.getToken}`, '_blank');
            break;

				  case 'lmsNew':
            window.open(`https://dev.new.lms.irisgst.com/token-verify?token=${this.getToken}`, '_blank');
            //window.open(`http://localhost:4100/token-verify?token=${this.getToken}`, '_blank');

            break;
            case 'lmsThree':
              window.open(`https://stage.lms.irisgst.com/authorise?token=${this.getToken}`, '_blank');
              //window.open(`http://localhost:4100/token-verify?token=${this.getToken}`, '_blank');

              break;
            case 'asap':
              //window.open(`https://app.asap.irisgst.com/`, '_blank');
               window.open(`https://${environment.asapUrl}/authorise?authToken=${this.getToken}`, '_blank');
              //window.open(`https://stage.app.asap.irisgst.com/authorise?authToken=${this.getToken}`, '_blank');
              //window.open(`http://localhost:4100/token-verify?token=${this.getToken}`, '_blank');

              break;
            case 'expressTDS':{
              if(this.dtUserDetails && this.dtUserDetails.signUp == false){
                this.signUpStep = 'OTP_NOT_SENT';
                this.modalService.open(this.signupTemplate, { ariaLabelledBy: 'modal-basic-title' });
              } else if(this.dtUserDetails && this.dtUserDetails.signUp == true){
                window.open(`https://${environment.expressTDSUrl}${this.dtLoginResp.token}`, '_blank');
              } else {
                window.open(`https://${environment.expressTDSUrl}/token-verify?token=${this.getToken}`, '_blank');
              }
              // window.open(`http://localhost:4100/token-verify?token=${this.getToken}`, '_blank');
              break;
            }
            default:
              break;
      }
    } else {
      this.tokenService.destroy();
      this.router.navigate(['login']);
    }
  }

  getSignUpOTP() {
    if(!this.isGetOTPInValid()) {
      let payload: any = {};
      if(this.dtUserRole === 'dt_master') {
        payload = {...this.dtSignupForm.value};
      } else {
        payload = {
          phone: this.dtSignupForm.value.phone
        }
      }
      this.authService.generateSignUpOTP(payload).subscribe((resp: any) => {
        if(resp && resp.status === 'SUCCESS') {
          this.signUpStep = 'OTP_SENT';
          this.toastr.success(resp.message);
        } else {
          if(resp && resp.errorList) {
            resp.errorList.forEach(e => {
              this.toastr.error(e.description);
            })
          } else {
            this.toastr.error(resp.message || 'Unable to generate OTP');
          }

        }
      })
    }
  }
  verifySignUpOTP() {
    this.signUpStep = 'OTP_VERIFIED';
    this.modalService.dismissAll();
    this.authService.verifySignUpOTP({
      otp: this.otpForm.value.otp
    }).subscribe((resp: any) => {
      if(resp && resp.status === 'SUCCESS') {
        if(resp.response) {
          this.toastr.success('OTP Verified Successfully!');
          this.dtLoginResp = resp.response;
          window.open(`https://${environment.expressTDSUrl}${this.dtLoginResp.token}`, '_blank');
          if(resp.response.token) {
            this.fetchDTUserDetails();
          }
        }
      }
    })
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  isGetOTPInValid() {
    if(this.dtUserRole === 'dt_master') return this.dtSignupForm.invalid;
    return this.dtSignupForm.value.phone === '' || this.dtSignupForm.value.phone.length !== 10;
  }
}
